//import { useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
//import { useDispatch } from 'react-redux';
import AppWrapper from './Components/AppWrapper/';
import ProtectedRoute, { AdditionalRequestWrapper, RequestAccessRouteWrapper } from './Components/ProtectedRoute';
import WorkItemRouteWrapper from './Components/DetermineWorkItem';
import Home from './Components/Home/';
import ViewParts from './Components/ViewParts/';
import AdditionalRequest from './Components/AdditionalAccessRequest';
import AdminRouter from './Components/Admin/adminRouter';
import RequestAccess from './Components/RequestAccess';
import FaqPage from './Components/FAQ';
import { authProvider } from './authProvider';
import store from './store';
import './App.css';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';



const App = () => {
  const headerObject = window.location.hostname.includes("beta") 
        ? { headerColor: 'green', headerModifier: ' DEV' }
        : window.location.hostname.includes("local")
            ? { headerColor: "#479906", headerModifier: ' LOCAL' }
            : { headerColor: "#140a9a", headerModifier: '' };
  
  const { headerColor, headerModifier } = headerObject;
  
  
  return (
    
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <AzureAD provider={authProvider} forceLogin={true} reduxStore={store}>
      {
        ({ authenticationState, error, accountInfo }) => {
                    
          return(
            authenticationState === AuthenticationState.Authenticated && accountInfo

              ? ( 
                  <Router>
                    <AppWrapper 
                      appHeaderText={ "Part Number Generator" + headerModifier }  
                      accountInfo={ accountInfo }                     
                      navColor={ headerColor }
                    >                
                      <Switch> 
                        <ProtectedRoute exact path="/">
                          <Home />
                        </ProtectedRoute>
                        <ProtectedRoute path="/myparts">
                          <ViewParts />
                        </ProtectedRoute>
                        <RequestAccessRouteWrapper path="/requestaccess">
                          <RequestAccess />
                        </RequestAccessRouteWrapper> 
                        <AdditionalRequestWrapper path="/requestadditionalaccess">
                          <AdditionalRequest />
                        </AdditionalRequestWrapper>                       
                        <ProtectedRoute requiresAdmin path="/admin/:id">
                          <AdminRouter />
                        </ProtectedRoute>                        
                        <ProtectedRoute path="/faq">
                          <FaqPage />
                        </ProtectedRoute>
                        <ProtectedRoute requiresAdmin path="/approveworkitem/:id">
                          <WorkItemRouteWrapper />
                        </ProtectedRoute>
                        <ProtectedRoute>
                          <div>404 page not found</div>
                        </ProtectedRoute>
                      </Switch> 
                    </AppWrapper> 
                  </Router>
                )
              : authenticationState === AuthenticationState.Unauthenticated
                &&                   
                ( 
                  error 
                    ? <div>There was an error during authentication, please try again</div> 
                    : <div>You will be redirected shortly to log in</div> 
                ) 
          )
        }
      }
      </AzureAD>
    </MuiPickersUtilsProvider>
  );
}

export default App;
